import { render, staticRenderFns } from "./HorizontalScrollContainer.vue?vue&type=template&id=534d7f2b&scoped=true&"
import script from "./HorizontalScrollContainer.vue?vue&type=script&lang=js&"
export * from "./HorizontalScrollContainer.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScrollContainer.vue?vue&type=style&index=0&id=534d7f2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534d7f2b",
  null
  
)

export default component.exports